import * as React from 'react';
import { useActions } from '../appActions';
import { AuthClient } from '../../../utils/authClient';
import { Overlay } from 'rcd-cpp-ui/ui/loader/Overlay';
import { Buttons, Secondary } from 'rcd-cpp-ui/ui/button';
import './sessionExpiry.scss';
import { useSelector } from '../../../utils/useSelector';
import { CookieManager, SessionDetails } from '../../../utils/cookieManager';

let sessionExpiryCheckInterval = null;
export const SessionExpiry = () => {
  const user = useSelector(s => s.app.user);
  const sessionExpiry = useSelector(s => s.app.sessionExpiry);
  const { setSessionExpiry } = useActions();

  React.useEffect(() => {
    if (!sessionExpiryCheckInterval && user) {
      sessionExpiryCheckInterval = setInterval(() => {
        AuthClient.getTokenExpiryInMs().then(async exp => {
          const c = CookieManager.getSessionDetails<SessionDetails>();
          const sessionExpiryCounter = c?.sessionExpiryCounter;
          if (!exp || exp <= 0) {
            if (!!sessionExpiryCounter && sessionExpiryCounter > 3) {
              setSessionExpiry({ expired: true });
            } else {
              await AuthClient.get().tokenManager.renew('accessToken');
              CookieManager.setSessionDetails<SessionDetails>({
                sessionExpiryCounter: sessionExpiryCounter + 1
              });
            }
          }
        });
      }, 60000);
    }
  }, [user]);

  if (!sessionExpiry?.expired) return null;
  return <RefreshOverlay>Your Session has Expired.</RefreshOverlay>;
};

export const RefreshOverlay = ({
  children
}: Pick<React.HTMLProps<HTMLDivElement>, 'children'>) => (
  <Overlay opaque fixed>
    <div id="sessionExpiryOverlay" className="slider-activator">
      <div>{children}</div>
      <Buttons>
        <Secondary
          label="Refresh"
          onClick={() => {
            window.location.href = window.location.href;
            //window.location.reload();
          }}
        />
      </Buttons>
    </div>
  </Overlay>
);
